// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-individual-pay.json
export class HrPayIndividualPayKey {
    private static readonly keyPrefix = 'hrPayIndividualPay';
    public static pageHeader = `${HrPayIndividualPayKey.keyPrefix}.pageHeader`;
    public static blockage = `${HrPayIndividualPayKey.keyPrefix}.blockage`;
    public static active = `${HrPayIndividualPayKey.keyPrefix}.active`;
    public static wageCode = `${HrPayIndividualPayKey.keyPrefix}.wageCode`;
    public static wageName = `${HrPayIndividualPayKey.keyPrefix}.wageName`;
    public static wageType = `${HrPayIndividualPayKey.keyPrefix}.wageType`;
    public static emptyStateMainTitle = `${HrPayIndividualPayKey.keyPrefix}.emptyStateMainTitle`;
    public static emptyStateSubtitle = `${HrPayIndividualPayKey.keyPrefix}.emptyStateSubtitle`;
}
